import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import img1 from "../about/img1.png";
import img from "../about/image.png";
import img3 from "../about/cnc.jpg"
import img2 from "../../components/log2.png";



const TypewriterText = ({ text, delay = 100 }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prevText) => prevText + text[currentIndex]);
        setCurrentIndex((prevIndex) => prevIndex + 1);
      }, delay);
      return () => clearTimeout(timeout);
    }
  }, [currentIndex, delay, text]);

  return <>{displayedText}</>;
};

const AboutHero = () => {
  const headingText = "Engineering Trust, Delivering Precision";
  const descriptionText =
    "With 45+ years of expertise, we craft high-quality fasteners and machined components that power industries worldwide-built on innovation, reliability, and customer-first values.";

  const images = [
    img1,
    img2,
    img3,
  ];

  return (
     <section className="bg-blue-200 py-20 px-4 md:px-12 lg:px-20">
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4">
      <div className="container mx-auto px-4 py-16 text-center">
        {/* Heading with Typewriter Animation */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-900 mb-6 max-w-4xl mx-auto leading-tight">
          <AnimatePresence>
            <motion.span
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <TypewriterText text={headingText} delay={70} />
            </motion.span>
          </AnimatePresence>
        </h1>

        {/* Description */}
        <p className="text-lg sm:text-xl text-gray-600 mb-12 max-w-3xl mx-auto">
          {descriptionText}
        </p>

        {/* Image Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full max-w-6xl mx-auto">
          {images.map((src, index) => (
            <motion.div
              key={index}
              className="bg-gray-100 rounded-2xl overflow-hidden shadow-lg aspect-video"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 + index * 0.15, duration: 0.5 }}
            >
             
              <img
                src={src}
                alt={`img-${index}`}
                className={`w-full h-full object-cover rounded-2xl 
                ${index === 1 ? "scale-75 mx-auto my-auto" : ""}`}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
    </section>
  );
};

export default AboutHero;
